<template>
  <div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useLISAThemesQuery, useLISAInstanceThemeUpdatedSubscription } from "../../../graphql";
import { cloneDeep } from "lodash";
import { useStore } from "vuex";
import isModifierSet from "../../../functions/userModifier";
import { ModifierType } from "../../../functions/userModifierEnum";
import { useLISAThemeProviderHelper } from "../helper/useLISAThemeProviderHelper";
import { normalizeLISATheme } from "../helper/LISATheme";

const { lisaTheme, loadCurrentTheme } = useLISAThemeProviderHelper();
loadCurrentTheme();
const store = useStore();
const { onResult: onQueryResult } = useLISAThemesQuery(() => {
  const userId = Number(store.getters["login/userId"]);
  return isModifierSet(ModifierType.enableUserThemes) ? { userIds: [userId] } : { instance: true };
});

onQueryResult((res) => {
  const theme = res.data?.LISAThemes[0];
  if (theme) {
    lisaTheme.value = normalizeLISATheme(cloneDeep(theme.theme));
  }
});

const { onResult } = useLISAInstanceThemeUpdatedSubscription();

onResult((res) => {
  if (
    res &&
    res.data &&
    res.data.LISAInstanceThemeUpdated &&
    isModifierSet(ModifierType.enableUserThemes) === false
  ) {
    lisaTheme.value = normalizeLISATheme(cloneDeep(res.data.LISAInstanceThemeUpdated.theme));
  }
});
</script>
